module.exports = __webpack_public_path__ + "img/ic_mobile_money.3f4a22a4.png";